(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    

  $('img').each(function(){
     $(this).addClass("img-fluid mx-auto d-block");
  });
  $('iframe').each(function(){
     $(this).wrap( "<div class='embed-responsive embed-responsive-16by9'></div>" );
     $(this).addClass("mx-auto d-block embed-responsive-item blog-video");
	 $(this).css("margin-top","50px");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bi-image-bottom"]) return;
  try {
    

   Tweet()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    

window.onload = function() {
   jQuery.post('/cart/update.js', {updates: {34697742273:1}});
        var price =  parseFloat($('.product-price').text().replace('$',''));
        var quantity = $('.input-quantity').val();
        var compute = price * quantity;
        var total = parseFloat(compute).toFixed(2);
          $('.txt-amount').text(total.toString())
};
  $(".txt-remove").click(function () {
     $('.section-cart-details').css("display", "none");
	 $('.section-cart-empty').css("display", "block");
     jQuery.post('/cart/update.js', {updates: {34697742273:0}});
   });

$(".input-quantity").bind('keyup mouseup', function (e) {
   if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode == 38) || (e.keyCode == 40) || (e.keyCode >= 96 && e.keyCode <= 105)) {
        var price =  parseFloat($('.product-price').text().replace('$',''));
        var quantity = $('.input-quantity').val();
        var compute = price * quantity;
        var total = parseFloat(compute).toFixed(2);
          $('.txt-amount').text(total.toString());
          jQuery.post('/cart/update.js', {updates: {34697742273: quantity}});

       if (quantity < 1) {
         $('.section-cart-details').css("display", "none");
         $('.section-cart-empty').css("display", "block");
         jQuery.post('/cart/update.js', {updates: {34697742273:0}});
	    }
    }
});

$(".input-quantity").click(function (event) {
        var price =  parseFloat($('.product-price').text().replace('$',''));
        var quantity = $('.input-quantity').val();
        var compute = price * quantity;
        var total = parseFloat(compute).toFixed(2);
          $('.txt-amount').text(total.toString());
          jQuery.post('/cart/update.js', {updates: {34697742273: quantity}});

       if (quantity < 1) {
         $('.section-cart-details').css("display", "none");
         $('.section-cart-empty').css("display", "block");
         jQuery.post('/cart/update.js', {updates: {34697742273:0}});
	    }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recent-blog"]) return;
  try {
    
          
   TweetBlog()


  } catch(e) { console.error(e); }
})();
})();
